import { StringDateTime } from './shared.model'

// MediaFile types
export enum MULTIMEDIA_TYPE {
  HEADER = 'HEADER',
  GALLERY = 'GALLERY',
  TICKET = 'TICKET',
}

export interface _MultimediaItem {
  /**
   * Common base for multimedia item models.
   */
  service: number
  heading: string
  alt_tag: string
  type: MULTIMEDIA_TYPE
  order: number
}

// Model for newly created multimedia file which are still only local
export interface LocalMultimediaItem extends _MultimediaItem {
  // Locally created id for item matching logic
  tempId: string
  file: File
}

// Model for existing multimedia file from server with id and file url
export interface ServerMultimediaItem extends _MultimediaItem {
  id: number
  file: string
  file_src_url?: string
  created_at: StringDateTime
  updated_at: StringDateTime
}

export interface MultimediaItem extends _MultimediaItem {
  /**
   * Model that encompasses both existing and new files
   */
  id?: number
  tempId?: string
  file: File | string
  file_src_url?: string
  order: number
  created_at?: StringDateTime
  updated_at?: StringDateTime
}

export interface UpdateMediaFile {
  heading: string
  alt_tag: string
  type: MULTIMEDIA_TYPE
  order: number
}
